module.exports = __webpack_public_path__ + "0875bbe1a9836b56b36be14b81e6e7d5.jpg";